import styled from 'styled-components'

interface IContainerProps {
  isChecked: boolean
}

export const Container = styled.div<IContainerProps>`
  display: flex;
  flex-direction: column;
  width: 260px;
  height: 265px;
  background-color: #fff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  // border: ${(props) => (props.isChecked ? '1px solid #387394;' : 'none')};
  margin-right: 20px;

  &:hover {
    transform: scale(1.01);
    transition: 0.3s;
  }
`

export const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Image = styled.img`
  width: 95%;
  height: 95%;
`

export const TextContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 8px 16px 0px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  background-color: #fbfbfb;
`

export const TitleContainer = styled.div`
  width: 100%;
  height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
`

export const ActionContainer = styled.div`
  width: 90%;
  height: 50%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`

export const CheckCircle = styled.div<{ checked: boolean }>`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: ${(props) => (props.checked ? '#C6016B' : '#ffffff')};
  border: 1px solid #c6016b;
  display: flex;
  justify-content: center;
  align-items: center;
`
